import React from 'react';
import { Mixpanel } from '../../redux/Mixpanel';
import _ from 'lodash';
import { connect } from 'react-redux';
import graphqlClient from '../../api/axios_interceptor';
import { UsernameCheckQuery } from '../../api/graphql/queries/authentication';
import ShowMoreButton from './ShowMoreButton';
import { Typeahead } from 'react-bootstrap-typeahead';
import { colorTheme } from '../../utils/constants';
import FormattedPhoneInput from '../../components/HandlePhoneNumbers/PhoneInputWithValidation';

import {
    Button,
    Row,
    Col,
    Table,
    Form,
    FormFeedback,
    FormGroup,
    Input,
    InputGroup,
    Container
} from 'reactstrap';

import CustomLabel from '../../components/CustomLabel';

import {
    check_empty_field,
    check_valid_email,
    check_phone_number

} from './validationChecks';

import {
    addTeamMember,
    updateTeamMember,
    deleteTeamMember,
    fetchPropertiesUnitsTenants,
    fetchTeam,
    showLoading,
    fetchOptions
} from '../../redux/actions';
import PhoneNumberFormatText from '../../components/PhoneNumberFormat';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import { IonButton, IonIcon } from '@ionic/react';
import { addOutline, refresh, trashOutline } from 'ionicons/icons';

const mapStateToProps = state => {
    return {
        properties: state.properties,
        team: state.team,
        options: state.options
    };
}

const mapDispatchToProps = {
    addTeamMember,
    updateTeamMember,
    deleteTeamMember,
    showLoading,
    fetchPropertiesUnitsTenants,
    fetchTeam,
    fetchOptions
};


class TeamForm extends React.Component{
    constructor(props){
        super(props);
        let teamMember = {
            username: "",
            personId: "",
            lastName: "",
            firstName: "",
            phoneNumber: "",
            phoneNumberFormatted: "",
            email: "",
            teamRole: ["editor"],
            showOptionalFields: false,
        };
        let checkedUsernameUnique = false;
        this.state = {
            ...teamMember,
            numErrors: 0,
            usernameFocused: false,
            usernameUnique: false,
            checkedUsernameUnique,
            teamRoleOptions: ["viewer", "editor", "admin"],
            userPerm: [],
            properties: [],
            propertiesOptions: [],
            errors: {
                username: "",
                lastName: "",
                firstName: "",
                phoneNumber: "",
                email: "",
                teamRole: "",
                properties: ""
            }
        };

    }

    async fetchInitialData() {
        await Promise.all([
          (async () => {
            if (_.isEmpty(this.props.properties)) {
              this.props.showLoading(true);
              await this.props.fetchPropertiesUnitsTenants();
            }
          })(),
            (async () => {
                if (_.isEmpty(this.props.team)) {
                this.props.showLoading(true);
                await this.props.fetchTeam();
                }
            })(),
            (async () => {
                if (_.isEmpty(this.props.options)) {
                    this.props.showLoading(true);
                    await this.props.fetchOptions();
                }
            })(),
        ]);
    }

    async componentDidMount(){
        await this.fetchInitialData();
        const propertiesOptions = Object.values(this.props.properties).map(
            (property, index) => { return this.getPropertyOption(property)}
        )

        let properties = [];
        let username = "";
        let lastName = "";
        let firstName = "";
        let phoneNumber = "";
        let phoneNumberFormatted = "";
        let email = "";
        let teamRole = ["editor"];
        let personId = "";
        personId = this.props.teamMemberId || "";
        let userPerm = this.props.options.allPermissions || [];

        let teamMember = this.props.team[personId];
        if (teamMember){
            personId = teamMember.personId || "";
            username = teamMember.username || "";
            lastName = teamMember.lastName || "";
            firstName = teamMember.firstName || "";
            phoneNumber = teamMember.phoneNumber || "";
            phoneNumberFormatted = teamMember.phoneNumber || "";
            email = teamMember.email || "";
            teamRole = [teamMember.role] || ["editor"];
            userPerm = teamMember.userPermissions || [];
            properties = teamMember.propertyIds.map((propertyId, index) => {
                return this.getPropertyOption(this.props.properties[propertyId]);
            });
        }
        this.setState({
            personId,
            username,
            lastName,
            firstName,
            phoneNumber,
            phoneNumberFormatted,
            email,
            teamRole,
            userPerm,
            propertiesOptions,
            properties,
            checkedUsernameUnique: teamMember? true : false
        })
    }

    getPropertyOption(property){
        return ({
            id: property.propertyId,
            label: property.propertyName
        });
    }

    async componentDidUpdate(prevProps, prevState) {
        if (!this.state.usernameFocused &&
            !this.state.checkedUsernameUnique &&
            this.state.username.length > 4
        ){
            await this.RequestUsernameCheck();
            this.setState({checkedUsernameUnique: true});
        }
    }

    async validateInput(name, value){
        let val = String(value);
        let isValid = true;
        let checks = [];

        switch(name){
            case "teamRole":
                checks = [check_empty_field];
                break;
            case "email":
                checks = [check_empty_field, check_valid_email];
                break;
            case "phoneNumber":
                checks = [check_phone_number];
                break;
            case "username":
                checks = [check_empty_field];
                break;
            default:
                break;

        }

        await this.setState((prevState) => {
            let errors = {...prevState.errors};
            let numErrors = prevState.numErrors;
            for (let index in checks){
                let previousError = prevState.errors[name];
                errors[name] = checks[index](val);

                if (errors[name].length > 0){
                    if (previousError.length == 0){
                        numErrors += 1
                    }
                    isValid = false;
                    break;
                }else if(previousError.length > 0){
                    numErrors -= 1
                }
            }
            return {
               errors,
               numErrors
            };
        });
        return isValid;
    }

    handleChange(event) {
        const target = event.target;
        let name = target.name;
        let val = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({[name]: val});

        this.validateInput(name, val);
    }

    async handleChangedOptions(name, selected) {
        if (selected.length === 1 && this.state.propertiesOptions.length === 1 && selected[0].label === this.state.propertiesOptions[0].label) {
          this.setState({[name]: selected}, () => {
            this.validateInput(name, selected);
          });
        } else {
          this.setState({[name]: selected}, () => {
            this.validateInput(name, selected);
          });
        }
      }

    async handleSubmit(event) {
        event.preventDefault();
        let fields = ["teamRole", "phoneNumber", "email", "username"];
        let results = [];
        let field;
        for(field of fields){
            let isValid = await this.validateInput(field, this.state[field])
            results.push(isValid);
        }
        let invalid_fields = results.filter( (x) => !x);

        if (invalid_fields.length == 0) {
            let teamMemberObj = {
                username: this.state.username,
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                phoneNumber: this.state.phoneNumberFormatted || this.state.phoneNumber,
                email: this.state.email,
                role: this.state.teamRole,
                propertyIds: this.state.properties.map((item, index) => item.id),
                userPerms: this.state.userPerm
            }
            this.props.showLoading(true);
            let result;
            if (this.state.personId === "" || this.state.personId === null) {
                result = await this.props.addTeamMember(teamMemberObj);
                if(result && result.payload){
                    let personId = result.payload.personId;
                    if (personId) {
                        this.setState({
                            personId
                        });
                    }

                }

            }else{
                this.props.updateTeamMember({
                    ...teamMemberObj,
                    personId: this.state.personId
                });
            }

        }
        Mixpanel.track("Team form: submit btn");
    }

    setTeamMemberValues(personId="", firstName="", properties=[],
        lastName="", username="", phoneNumber="+254", email="", phoneNumberFormatted="", teamRole=["editor"], userPerm=[]){
            userPerm = this.props.options.allPermissions || [];
            const currentSearch = window.location.search;
            const updatedSearch = currentSearch.replace(/([&?])teamMemberId=[^&]+/, '');
            window.history.replaceState(null, '', `${window.location.pathname}${updatedSearch}`);
            this.setState({
                personId, firstName, lastName, username, properties, teamRole,
                phoneNumber, email, phoneNumberFormatted, userPerm
        });
    }

    handleDelete(personId, event) {
        event.preventDefault();
        if (window.confirm("Are you sure you want to delete this team member?")) {
            this.props.showLoading(true);
            this.setTeamMemberValues();
            this.props.deleteTeamMember(personId);
            Mixpanel.track("Team form: delete btn");
        }
    }

    handleCancelUpdate(event){
        event.preventDefault();
        this.setTeamMemberValues();
        Mixpanel.track("Team form: cancel update btn");
    }

    handleClear(event){
        event.preventDefault();
        this.setTeamMemberValues();
        Mixpanel.track("Team form: clear btn");
    }


    editTeamMember(teamMember, event){
        event.preventDefault();
        this.setState({
            ...teamMember,
        });
    }

    async handleUsernameEntry(event){
        event.preventDefault();
        let newErrors = { ...this.state.errors };
        if (event.target.value.length < 5){
            newErrors.username = "Username should be more than 4 characters long";
        } else {
            newErrors.username = ""
        }
        this.setState({
            errors: newErrors,
            username: event.target.value,
            checkedUsernameUnique: false
        });
    }

    async RequestUsernameCheck (){
        try {
            const query = UsernameCheckQuery(this.state.username);
            await graphqlClient({
                data: {
                  query: query
                }
              }).then((queryResult) => {
                let newErrors = { ...this.state.errors };
                let usernameUnique = false;
                if (queryResult.data.data.users.edges.length < 1){
                    usernameUnique = true;
                    newErrors.username = "";
                }else{
                    newErrors.username = "The username you have entered already exists";
                }
                this.setState({errors: newErrors, usernameUnique});
              });

        } catch (error) {
            console.error(error);
        }
    }

    renderTable(){
        return (
            <Row>
                <Table>
                    <thead>
                        <tr>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Phone Number</th>
                            <th>Email</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        {_.map(Object.values(this.props.team), (member, index) => (
                            <tr key={member.personId}>
                                <td>
                                    <a
                                    style={{textDecorationLine: 'underline', color:'blue'}}
                                    onClick={this.editTeamMember.bind(this, member)}
                                    >
                                        {member.firstName}
                                    </a>
                                </td>
                                <td>{member.lastName}</td>
                                <td>{member.phoneNumber}</td>
                                <td>{member.email}</td>
                                <td>
                                    <a onClick={this.handleDelete.bind(this, member.personId)}>
                                        <i className="fa fa-close text-danger"></i>
                                    </a>
                                </td>
                            </tr>
                        ))
                        }
                    </tbody>
                </Table>
            </Row>
        )
    }

    renderRequiredFields(){
        return (
            <React.Fragment>
                {/* username */}
                <FormGroup row>
                    <CustomLabel for="username">
                        username
                    </CustomLabel>
                    <Col style={{maxWidth: '450px'}} xs={12} sm={12}>
                        <Input
                            id="username"
                            name="username"
                            autoComplete="off"
                            readOnly={this.state.personId}
                            placeholder='username'
                            onFocus={() => this.setState({usernameFocused: true})}
                            onBlur={() => this.setState({usernameFocused: false})}
                            value={this.state.username}
                            onChange={this.handleUsernameEntry.bind(this)}
                            invalid={this.state.errors.username.length > 0}
                        />
                        <p><span className="text-danger">{this.state.personId? "(read only)" : ""}</span></p>
                        <FormFeedback>{this.state.errors.username}</FormFeedback>
                    </Col>
                </FormGroup>

                {/* Email */}
                <FormGroup row>
                    <CustomLabel for="email">
                        Email
                    </CustomLabel>
                    <Col style={{maxWidth: '450px'}} xs={12} sm={12}>
                        <Input
                            id="email"
                            name="email"
                            autoComplete="off"
                            placeholder="Please enter an email"
                            value={this.state.email}
                            onChange={this.handleChange.bind(this)}
                            invalid={this.state.errors.email.length > 0}
                        />
                        <FormFeedback>{this.state.errors.email}</FormFeedback>
                        <p>Used for password recovery</p>
                    </Col>
                </FormGroup>

                {/* Team Role */}
                <FormGroup row>
                    <CustomLabel for="Role">
                        Role
                    </CustomLabel>
                    <Col style={{maxWidth: '450px'}} xs={12} sm={12}>
                        <Typeahead
                            emptyLabel={"Please select team member role."}
                            id="Role"
                            clearButton
                            options={this.state.teamRoleOptions}
                            name="Role"
                            selected={this.state.teamRole}
                            onChange={this.handleChangedOptions.bind(this, "teamRole")}
                        >
                        </Typeahead>
                        {this.state.errors.teamRole.length > 0 && (
                            <p className="text-danger">{this.state.errors.teamRole}</p>
                        )}
                    </Col>
                </FormGroup>


                {/* Properties */}
                <FormGroup row>
                    <CustomLabel for="properties">
                        Properties Managed
                    </CustomLabel>
                    <Col style={{maxWidth: '450px'}} xs={12} sm={12}>
                    <Typeahead
                            emptyLabel={"Please select team member properties."}
                            id="properties"
                            clearButton
                            multiple
                            placeholder='Please select property(s)'
                            options={this.state.propertiesOptions}
                            name="properties"
                            className='type-ahead-custom'
                            selected={this.state.propertiesOptions.length === 1? [this.state.propertiesOptions[0]] : this.state.properties}
                            onChange={this.handleChangedOptions.bind(this, "properties")}
                            style={{ color: 'black', display: "flex"}}
                        >
                        </Typeahead>
                        {this.state.errors.properties.length > 0 && (
                            <p className="text-danger">{this.state.errors.properties}</p>
                        )}
                    </Col>
                </FormGroup>



            </React.Fragment>
        );
    }

    renderOptionsFields(){
        return (
            <React.Fragment>

                {/* Phone number */}
                <FormGroup row>
                    <CustomLabel for="phoneNumber">
                        Phone Number (optional)
                    </CustomLabel>
                    <Col style={{maxWidth: '450px'}} xs={12} sm={12}>
                        <InputGroup>
                        <FormattedPhoneInput
                            country={'ke'}
                            phoneNumber={this.state.phoneNumber}
                            onPhoneNumberChange={(value, formatted) => this.setState({ phoneNumber: value ,phoneNumberFormatted: formatted })}
                            fieldName={"phoneNumber"}
                            onPhoneNumberValidation={this.validateInput.bind(this)}
                        />
                        </InputGroup>
                        <PhoneNumberFormatText/>
                        <p className='text-danger'><small>{this.state.errors.phoneNumber.length > 0 ? this.state.errors.phoneNumber : ""}</small></p>
                        <p>Used to send text alerts</p>
                    </Col>
                </FormGroup>

                {/* First Name */}
                <FormGroup row>
                    <CustomLabel for="firstName">
                        First Name (optional)
                    </CustomLabel>
                    <Col style={{maxWidth: '450px'}} xs={12} sm={12}>
                        <Input
                            id="firstName"
                            name="firstName"
                            autoComplete="off"
                            placeholder='First Name'
                            value={this.state.firstName}
                            onChange={this.handleChange.bind(this)}
                            invalid={this.state.errors.firstName.length > 0}
                        />
                        <FormFeedback>{this.state.errors.firstName}</FormFeedback>
                    </Col>
                </FormGroup>

                {/* Last Name */}
                <FormGroup row>
                    <CustomLabel for="lastName">
                        Last Name (optional)
                    </CustomLabel>
                    <Col style={{maxWidth: '450px'}} xs={12} sm={12}>
                        <Input
                            id="lastName"
                            name="lastName"
                            autoComplete="off"
                            placeholder='Last name ...'
                            value={this.state.lastName}
                            onChange={this.handleChange.bind(this)}
                            invalid={this.state.errors.lastName.length > 0}
                        />
                        <FormFeedback>{this.state.errors.lastName}</FormFeedback>
                    </Col>
                </FormGroup>
                {/*Team Member Permissions*/}
                <FormGroup row>
                    <div row className='mt-4 mb-3' style={{ width: "100vw"}}>
                        <h5><b>Team Member Permissions</b></h5>
                        <p>Use these settings to determine whether the team member should only view or be able to create, edit and view.</p>
                    </div>
                    <Col>
                        {this.state.userPerm.map((perm, index) => (
                            <Row>
                            <Col lg={5} md={5} sm={5} xs={5}>
                                <p className='font-weight-bold'>{perm.model}</p>
                            </Col>

                            <Col lg={3} md={3} sm={3} xs={3}>

                            <Input
                                type="checkbox"
                                id={perm.model + 'View'}
                                name={perm.model + 'View'}
                                checked={perm.view}
                                onChange={(e) => {
                                let userPerm = [...this.state.userPerm];
                                userPerm[index].view = e.target.checked;
                                userPerm[index].all = false;
                                this.setState({ userPerm });
                                }}
                            />
                            &nbsp; <label htmlFor={perm.model + 'View'} className=''>View</label>
                            </Col>
                            <Col lg={3} md={3} sm={3} xs={3}>
                            <Input
                                type="checkbox"
                                id={perm.model + 'All'}
                                name={perm.model + 'All'}
                                checked={perm.all}
                                onChange={(e) => {
                                let userPerm = [...this.state.userPerm];
                                userPerm[index].all = e.target.checked;
                                userPerm[index].view = false;
                                this.setState({ userPerm });
                                }}
                            />
                            &nbsp; <label htmlFor={perm.model + 'All'} className=''>
                                All
                            </label>
                            </Col>
                            </Row>
                        ))}
                    </Col>
                </FormGroup>

            </React.Fragment>
        );
    }

    renderButtons(){
        return (
            <Row className="d-flex mb-4 pb-3 border-bottom border-dark justify-content-center">
                <IonButton type="submit"
                    className="shadow py-1"
                    style={{width:"80%"}}
                    onClick={this.handleSubmit.bind(this)}
                    disabled={this.state.numErrors > 0}>
                    {this.state.personId?
                        <span><IonIcon icon={refresh}></IonIcon>Update Team Member</span>:
                        <span><IonIcon icon={addOutline}></IonIcon>Add Team Member</span>
                    }
                </IonButton>

                {this.state.personId && (<IonButton
                    type="submit"
                    style={{ width: "80%" }}
                    fill='outline'
                    onClick={this.handleClear.bind(this)}
                >
                    <span><IonIcon icon={addOutline}></IonIcon>Add Another Team Member</span>
                </IonButton>)}
            </Row>
        )
    }

    render(){
        return (
            <Container style={{ display: "flex", justifyContent: "center" }}>

                <Col md={9} className=''>
                    <Row className="mb-2 mt-1">

                        <Col className='d-flex justify-content-end' lg={12} md={12} sm={12} xs={12}>
                            {this.state.personId && (<IonButton
                                size="lg"
                                color="medium"
                                className="mx-2 shadow"
                                id="deleteButton"
                                title="delete"
                                draggable={true}
                                onClick={this.handleDelete.bind(this, this.state.personId)}
                            >
                                <IonIcon icon={trashOutline}></IonIcon>
                            </IonButton>)}
                        </Col>
                    </Row>

                    <Row>
                        <Col lg={12}>
                        <Form onSubmit={this.handleSubmit.bind(this)}>

                            {this.renderRequiredFields()}

                            <ShowMoreButton
                                id="showOptionalFields"
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.setState((prevState) => ({showOptionalFields: !prevState.showOptionalFields}))
                                }}
                                showMore={this.state.showOptionalFields}
                            />

                            {this.state.showOptionalFields && this.renderOptionsFields()}

                            {this.renderButtons()}


                        </Form>
                        </Col>
                    </Row>

                {this.props.showTable && this.renderTable() }

                </Col>

            </Container>
        );
    }
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(TeamForm));